import { Drawer } from 'antd';
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';
import FilterSelect from "components/Form/filterSelect";
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { activeStatusOptions, eosOptions, genderOptions, maritalStatusOptions } from 'utils/constants';

const FilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll

}) => {
  const [placement] = useState('right');  
   const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    costCenter, costCenterLoading
} = useSelector((state) => state.common);

const [reportOption, setReportOption] = useState([]);
const [departmentOption, setDepartmentOption] = useState([]);
const [nationalityOption, setNationalityOption] = useState([]);
const [positionOption, setPositionOption] = useState([]);
const [divisionOption, setDivisionOption] = useState([]);

const [costCenterOption, setCostCenterOption] = useState([]);


useEffect(()=>{
    let _reports = reportTo.map(item=> {
        return{
            label: `${item.first_name} ${item.last_name || ""}`.trim(),
            value: item.user_id
        }
    })
    let _departments = department.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    let _nationality = nationality.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    let _position = position.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    let _division = division.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })

    let cost_center = costCenter.map(item=> {
      return{
          label: item.name || item.code,
          value: item.id
      }
  })
  
    setReportOption(_reports)
    setDepartmentOption(_departments)
    setNationalityOption(_nationality)
    setPositionOption(_position)
    setDivisionOption(_division)
    setCostCenterOption(cost_center)
},[department, reportTo, nationality, position, division, costCenter])





   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedFilter = [...filters].find(item=> item.key === key)
        if(selectedFilter?.value){
          if(key === "nationality"){
            // For multi-select, return the array of option objects
            if(Array.isArray(selectedFilter.value)){
              return selectedFilter.value.map(val => {
                if(typeof val === 'object' && val !== null) {
                  // If it's already an object with value/label, find matching option
                  return nationalityOption.find(opt => opt.value == val.value) || val
                }
                // If it's a primitive value (ID), find matching option
                return nationalityOption.find(opt => opt.value == val) || {value: val, label: String(val)}
              }).filter(Boolean)
            }
            // If it's a string (comma-separated IDs), convert to array
            if(typeof selectedFilter.value === 'string' && selectedFilter.value){
              const ids = selectedFilter.value.split(',').map(id => id.trim())
              return ids.map(id => nationalityOption.find(opt => opt.value == id)).filter(Boolean)
            }
            return []
          }
          
          // For single select, find the matching option object from the options array
          let filterValue = selectedFilter.value
          
          // Convert to string for comparison if needed
          if(typeof filterValue === 'number'){
            filterValue = String(filterValue)
          }
          
          switch(key){
            case "gender":
              return genderOptions.find(opt => String(opt.value) === String(filterValue)) || null
            case "report_to":
              return reportOption.find(opt => String(opt.value) === String(filterValue)) || null
            case "department":
              return departmentOption.find(opt => String(opt.value) === String(filterValue)) || null
            case "position":
              return positionOption.find(opt => String(opt.value) === String(filterValue)) || null
            case "division":
              return divisionOption.find(opt => String(opt.value) === String(filterValue)) || null
            case "marital_status":
              return maritalStatusOptions.find(opt => String(opt.value) === String(filterValue)) || null
            case "cost_center":
              return costCenterOption.find(opt => String(opt.value) === String(filterValue)) || null
            case "status":
              return [{label: "All", value: "all"},...activeStatusOptions].find(opt => String(opt.value) === String(filterValue)) || null
            case "eos_approved":
              return eosOptions.find(opt => String(opt.value) === String(filterValue)) || null
            default:
              return null
          }
        }
    }

    return null

  }, [filters, genderOptions, reportOption, departmentOption, positionOption, divisionOption, maritalStatusOptions, costCenterOption, activeStatusOptions, eosOptions, nationalityOption]);

//   useEffect(()=>{
//     console.log(filters, "Filters")
//     let _employmentDateAfter = filters.find(item=> item.key === "employment_date_after")?.value
//     let _employmentDateBefore = filters.find(item=> item.key === "employment_date_before")?.value
//     console.log(_employmentDateAfter, _employmentDateBefore, "Start Date, End Date")
//     setEmploymentDateAfter(_employmentDateAfter)
//     setEmploymentDateBefore(_employmentDateBefore)
// },[filters])

  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        closeIcon={
          <span 
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#fee2e2",
              color: "#dc2626",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "18px",
              fontWeight: "600"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#fecaca";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fee2e2";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <i className='la la-close' />
          </span>
        }
      >
         <div className="col mb-3 d-flex justify-content-between align-items-center">
          <h3 className="page-title" style={{ margin: 0 }}>Filters</h3>
          <span 
            onClick={handleFilterDrawer}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#fee2e2",
              color: "#dc2626",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "18px",
              fontWeight: "600"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#fecaca";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fee2e2";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <i className='la la-close' />
          </span>
        </div>
        <div className='col-12 mb-3' >
        <DateInput 
        value={(() => {
          const filter = filters.find(f => f.key === "employment_date_after")
          return filter?.value || ""
        })()}
        onChange={e=>{handleDateChange(e.target.value, "employment_date_after")}} 
        id="employment_date_after" 
        label={"Joined after"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        value={(() => {
          const filter = filters.find(f => f.key === "employment_date_before")
          return filter?.value || ""
        })()}
        onChange={e=>{handleDateChange(e.target.value, "employment_date_before")}} 
        id="employment_date_before" 
        label={"Joined before"} 
        />
        </div>



        {/* <div className='col-12 mb-3' >
        <FilterInput   inputValue={setInputValue("search")}  handleInputChange={e=>{handleInputChange(e.target.value, "search")}} id="search" placeholder={searchPlaceholder} />
        </div> */}
       

        {/* <div className='col-12 mb-3' >
        <FilterSelect loading options={[]} value={""} placeholder={"Select destination"}/>
        </div> */}

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "gender")}} optionLabel={"label"} optionValue={'value'} options={genderOptions} value={setFilterValue("gender")} placeholder={"Gender"}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "report_to")}} optionLabel={"label"} optionValue={'value'} isLoading={reportToLoading} value={setFilterValue("report_to")} options={reportOption}  placeholder={"Report to"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'}  options={departmentOption} isLoading={departmentLoading}  value={setFilterValue("department")} placeholder={"Department"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isMulti={true} isClearable={true}  onChange={e=>{handleFilterChange(e, "nationality")}} optionLabel={"label"} optionValue={'value'}  options={nationalityOption} isLoading={nationalityLoading}  value={setFilterValue("nationality")} placeholder={"Nationality"}/>
        </div>

         <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "position")}} optionLabel={"label"} optionValue={'value'}  options={positionOption} isLoading={positionLoading} value={setFilterValue("position")} placeholder={"Designation"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "division")}} optionLabel={"label"} optionValue={'value'}  options={divisionOption} isLoading={divisionLoading} value={setFilterValue("division")} placeholder={"Division"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "marital_status")}} optionLabel={"label"} optionValue={'value'} options={maritalStatusOptions}  value={setFilterValue("marital_status")} placeholder={"Marital Status"}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'} options={costCenterOption}  value={setFilterValue("cost_center")} placeholder={"Cost Center"} isLoading={costCenterLoading}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "status")}} optionLabel={"label"} optionValue={'value'} options={[{label: "All", value: "all"},...activeStatusOptions]}  value={setFilterValue("status")} placeholder={"Status"} />
        </div>


        <div className='col-12 mb-3' >
          <DateInput 
            value={(() => {
              const filter = filters.find(f => f.key === "resigned_date_after")
              return filter?.value || ""
            })()}
            onChange={e=>{handleDateChange(e.target.value, "resigned_date_after")}} 
            id="resigned_date_after" 
            label={"Resigned after"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <DateInput 
            value={(() => {
              const filter = filters.find(f => f.key === "resigned_date_before")
              return filter?.value || ""
            })()}
            onChange={e=>{handleDateChange(e.target.value, "resigned_date_before")}} 
            id="resigned_date_before" 
            label={"Resigned before"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <FilterSelect 
            isClearable={true} 
            onChange={e=>{handleFilterChange(e, "eos_approved")}} 
            optionLabel={"label"} 
            optionValue={'value'} 
            options={eosOptions}  
            value={setFilterValue("eos_approved")} 
            placeholder={"End of service"} 
          />
        </div>

        <div className="col-12">
          {filters.some(filter => filter.value && filter.key !== "search") && (
            <Button 
              label="Clear All" 
              onClick={handleClearAll}
              className="btn btn-outline-secondary w-100 mb-3"
              style={{ borderRadius: "8px" }}
            />
          )}
          <Button 
            label="Search" 
            loading={filterLoading} 
            disabled={filterLoading} 
            onClick={handleApplyFilter}   
            className="btn btn-primary w-100"
            style={{ borderRadius: "8px" }}
          />
     </div>

      </Drawer>
    </>
  );
};
export default FilterDrawer;